module.exports = __webpack_public_path__ + "img/html.93f5ab69.png";